module.exports = __webpack_public_path__ + "static/media/toaster.86186669.png";